/**
 * Reading a checkbox out of text.
 *
 * A boolean field stores a boolean, so this exists entirely for the places
 * text arrives from somewhere else: a paste from a spreadsheet, a character
 * typed straight into the cell, and the primary-field text a link row carries.
 *
 * The list is the backend's, in `fields/constants.py`, which is DRF's
 * `BooleanField.TRUE_VALUES` plus `checked`. It is compared lowercased and
 * trimmed rather than held in every case the backend enumerates, and there is
 * deliberately no *false* list: anything that is not recognisably true is
 * false, which is the only reading under which pasting a blank cell over a
 * ticked one unticks it.
 *
 * `o` is not the backend's and is kept because upstream's frontend has always
 * had it, and dropping it would silently change what an existing paste does.
 */
const TRUE_VALUES = ['t', 'y', 'yes', 'true', 'o', 'on', '1', 'checked']

/**
 * Whether a value means "ticked".
 *
 * Anything that is neither a boolean nor text is false. The backend's list
 * carries the numbers as well, because a JSON body can hold one; nothing that
 * reaches here can, since a checkbox cell holds a boolean and everything else
 * arrives as text.
 */
export function parseBooleanValue(value: unknown): boolean {
  if (typeof value === 'boolean') return value
  if (typeof value !== 'string') return false
  return TRUE_VALUES.includes(value.toLowerCase().trim())
}
